/* eslint-disable */
import Swiper from "swiper/bundle";
/* eslint-enable */

class GridArbitraryMobileGallery {
  constructor(args = { sectionsContainer: document }) {
    this.sectionsContainer = args.sectionsContainer;
    this.sliderGallerySections = this.sectionsContainer.getElementsByClassName("grid-arbitrary-mobile-gallery");
    this.swiperInstance = null;
    if (this.sliderGallerySections !== null) {
      this.addResizeListener();
    }
  }

  addResizeListener() {
    window.addEventListener('resize', () => {
      console.log('resize detected');
      this.handleResize();
    });

    this.handleResize();
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    const section = this.sliderGallerySections[0]; 
    if (!section) {
      return;
    }

    if (isMobile && !this.swiperInstance) {
      const swiperContainer = section.querySelector(".swiper-container");
      this.swiperInstance = new Swiper(swiperContainer, {
        grabCursor: true,
        loop: false,
        slidesPerView: this.getSlidesPerView(),
        spaceBetween: 20,
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    } else if (!isMobile && this.swiperInstance) {
      this.swiperInstance.destroy();
      this.swiperInstance = null;
    } else if (this.swiperInstance) {
      this.swiperInstance.params.slidesPerView = this.getSlidesPerView();
      this.swiperInstance.update();
    }
  }

  getSlidesPerView() {
    const width = window.innerWidth;

    if (width <= 576) {
      return 1.05;
    } else  {
      return 2.1; 
    }
  }
}

export default GridArbitraryMobileGallery;
